import React, { FC } from 'react';
import { Props } from './types';
import { Container } from './styles';

const DataView: FC<Props> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default DataView;
